import React from "react";
import { connect } from 'react-redux';
import { format } from 'date-fns'

const CustomerBookings = ({
  services,
  teamMembers,
  locations,
  customer
}) => {

  const bookings = customer.bookings && customer.bookings.items

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col">
        <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Date & Time
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Location
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Team Member
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Service(s)
                  </th>
                  {/*<th className="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>*/}
                </tr>
              </thead>
              <tbody className="bg-white">
                {bookings?.map((booking, index) => {
                  const teamMember = booking.teamMemberID && teamMembers && teamMembers.find(item => item.id == booking.teamMemberID)
                  return (
                    <tr key={booking.id}>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
                        {format(new Date(booking.date), 'dd/MM/yyyy')} {booking.startTime}
                      </td>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                        {booking.locationID && locations && locations.find(item => item.id == booking.locationID)?.name}
                      </td>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                        {teamMember && teamMember.givenName} {teamMember && teamMember.familyName}
                      </td>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                        {booking.services && services && booking.services.map(i => services.find(item => item.id == i.service)?.name).join(', ')}
                      </td>
                      {/*<td className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-sm leading-5 font-medium">
                        <Link to={`/customer/${customer.id}`}  className="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline">Edit</Link>
                      </td>*/}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    customer: state.customer.item,
    services: state.service.list,
    teamMembers: state.teamMember.list,
    locations: state.location.list,
  }
}

const mapDispatchToProps = dispatch => ({
  // getCustomer: (id) => dispatch(ACTIONS.getItem(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerBookings) 